import dayjs from 'dayjs';

export const isNew = (notificationParam, checkedAt) => {
  if (!checkedAt) return true;
  return dayjs(checkedAt).isBefore(dayjs(notificationParam.createdAt));
};
